import { Box, Tab, Tabs } from '@mui/material';
import { useState, useEffect } from 'react';
import OverviewComponent from '../Collections/OverviewComponent';
import AuthorizationComponentWithAutoSave from "../Collections/AuthorizationComponentWithAutoSave";
import VariablesComponent from '../Common/VariablesComponent';

const FolderScreen = ({ state, folder }) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      label: "Overview",
      component: <OverviewComponent resource={folder || state.selectedFolder} />
    },
    {
      label: "Authorization",
      component: <AuthorizationComponentWithAutoSave allowInheritFromParent={true} />
    },
    {
      label: "Variables",
      component: <VariablesComponent resource={folder} resourceType={'Folder'} />
    }
  ];

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    setActiveTab(0);
  }, [folder]);

  return (
    <Box sx={{ backgroundColor: 'var(--background-primary)', flexGrow: 1, maxHeight: 'calc(100vh - 37px)', color: 'var(--text-primary)' }}>
      <Box sx={{ paddingTop: '10px' }}>
        <Tabs
          className='tab-style'
          value={activeTab}
          onChange={handleTabChange}
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            border: "1px solid var(--borderColor)",
            borderRadius: "8px"
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={tab?.label}
              label={tab?.label}
              sx={{
                minHeight: '32px',
                height: '32px',
                textTransform: 'none',
                color: activeTab === index ? 'white' : 'var(--text-secondary)',
                backgroundColor: activeTab === index ? 'var(--primary-color)' : 'var(--background-layout)',
                fontWeight: activeTab === index ? "500" : "400",
                fontSize: "12px",
                "&:hover": {
                  backgroundColor: 'var(--hover-bg)',
                  color: "var(--text-primary)"
                },
                "&.Mui-selected": {
                  color: "white",
                  backgroundColor: "var(--primary-color)", // if you also want to change background
                }
              }}
            />
          ))}
        </Tabs>
        {/* FIXME :: Something still wrong. Temporarily fixing with maxHeight */}
        <Box sx={{ padding: '15px', paddingBottom: 10, overflowY: 'auto', maxHeight: "calc(100vh - 135px)" }}>
          {tabs[activeTab].component}
        </Box>
      </Box>
    </Box >
  );
}

export default FolderScreen;
